import type { Checkout } from '@vp/common';
import { HARD_CODED_USD_CHANGE_ME } from '@vp/common/util';

// Venue currencies are stored lowercase — admin's venue form offers 'usd'/'cad'/'eur'/
// 'aud' — and Intl.NumberFormat canonicalizes case, so the price-rendering path never
// exposed it. GA4, Meta, TikTok and Reddit all want uppercase ISO-4217 and treat
// anything else as invalid, dropping the value they were sent rather than converting
// it. So the tracking payloads normalize here, while formatCurrency keeps the raw code.
export const trackingCurrency = (currency?: string): string => {
  const code = (currency ?? '').trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : HARD_CODED_USD_CHANGE_ME;
};

export const eventTrackingCurrency = (event?: Checkout.CheckoutEvent.CheckoutEvent): string =>
  trackingCurrency(event?.venue?.currency);
